import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdJobsId } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { Job } from '~hooks/useJob/models';
import connection from '~services/connectionModule';

export default function useJobQuery(companyId: string, jobId: string | undefined) {
  const query = useQuery({
    queryKey: ['job', companyId, jobId],
    queryFn:
      companyId && jobId
        ? async ({ signal }) => {
            try {
              const response = await getV1CompaniesCompanyIdJobsId({
                path: { 'company-id': companyId, id: jobId },
                signal,
              });

              return Job.parse(response.data.data);
            } catch (error) {
              connection.handleRequestError(
                error,
                t('error_messages.jobs.failed_to_fetch_individual_job'),
              );
              throw error;
            }
          }
        : skipToken,
    retry: false,
  });

  return { isLoading: query.isLoading, job: query.data };
}
